import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import JsonDialog from '../../JsonDialog';
import CreateAppointmentEventValue from './CreateAppointmentEventValue';
import FailedAppointmentEventValue from './FailedAppointmentEventValue';
import AppointmentOfferEventValue from './AppointmentOfferEventValue';
import ConfirmAppointmentOfferEventValue from './ConfirmAppointmentOfferEventValue';
import AppointmentInfoEventValue from './AppointmentInfoEventValue';
import TranscribeVoiceMailEventValue from './TranscribeVoiceMailEventValue';
import MediaUploadEventValue from './MediaUploadEventValue';
import EscalateMessageEventValue from './EscalateMessageEventValue';

const EventValue = ({ event }) => {
  const [jsonDialog, setJsonDialog] = useState({ isOpen: false, data: null, title: '' });
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useLanguage();

  const getEventValue = (event) => {
    if (typeof event.value === 'string') {
      return event.value;
    } else if (event.value && typeof event.value === 'object') {
      return JSON.stringify(event.value, null, 2);
    }
    return t('eventType.noMessageContent');
  };

  const getEventTypeLabel = (eventType, key) => {
    if (eventType === 'create' && key === 'notify_clinic_by_human') {
      return t('eventType.clinicNotification');
    } else if (eventType === 'leave_message' && key === 'notification') {
      return t('eventType.leaveMessage');
    } else if (eventType === 'create' && key === 'appointment') {
      return t('eventType.createAppointment');
    } else if (eventType === 'failed' && key === 'appointment') {
      return t('eventType.failedAppointment');
    } else if (eventType === 'create' && key === 'appointment_offer') {
      return t('eventType.createAppointmentOffer');
    } else if (eventType === 'confirm' && key === 'appointment_offer') {
      return t('eventType.confirmAppointmentOffer');
    } else if (eventType === 'create' && key === 'appointment_info') {
      return t('eventType.submitForm');
    } else if (eventType === 'update' && key === 'appointment_info') {
      return t('eventType.updateAppointmentInfo');
    } else if (eventType === 'create' && key === 'media_upload') {
      return t('eventType.mediaUpload');
    } else if (eventType === 'escalate_message' && key === 'notification') {
      return t('eventType.escalateMessage');
    }
    return `${eventType} - ${key}`;
  };

  const isJsonMessage = (event) => {
    if (typeof event.value === 'string') {
      try {
        JSON.parse(event.value);
        return true;
      } catch {
        return false;
      }
    } else if (event.value && typeof event.value === 'object') {
      return true;
    }
    return false;
  };

  const handleShowJsonDialog = (event) => {
    const jsonData = typeof event.value === 'string' ? JSON.parse(event.value) : event.value;
    setJsonDialog({
      isOpen: true,
      data: jsonData,
      title: `${t('eventType.jsonData')} - ${getEventTypeLabel(event.event_type, event.key)}`
    });
  };

  const handleCloseJsonDialog = () => {
    setJsonDialog({ isOpen: false, data: null, title: '' });
  };

  return (
    <>
      {
        (() => {
          if (event.event_type === 'create' && event.key === 'appointment') {
            return <CreateAppointmentEventValue event={event} />;
          }
          else if (event.event_type === 'failed' && event.key === 'appointment') {
            return <FailedAppointmentEventValue event={event} />;
          }
          else if (event.event_type === 'create' && event.key === 'appointment_offer') {
            return <AppointmentOfferEventValue event={event} />;
          }
          else if (event.event_type === 'confirm' && event.key === 'appointment_offer') {
            return <ConfirmAppointmentOfferEventValue event={event} />;
          }
          else if ((event.event_type === 'update' || event.event_type === 'create') && event.key === 'appointment_info') {
            return <AppointmentInfoEventValue event={event} />;
          }
          else if (event.event_type === 'transcribe_voice_mail' && event.key === 'voice_mail') {
            return <TranscribeVoiceMailEventValue event={event} />;
          }
          else if (event.event_type === 'create' && event.key === 'media_upload') {
            return <MediaUploadEventValue event={event} />;
          }
          else if (event.event_type === 'escalate_message' && event.key === 'notification') {
            return <EscalateMessageEventValue event={event} />;
          }
          else {
            return (
              <div className="flex-1 break-words bg-blue-100 p-2 rounded-md border border-blue-200" title={getEventValue(event)}>
                {getEventValue(event)}
              </div>
            );
          }
        })()
      }
      {/* {
        isJsonMessage(event) && (
          <button
            onClick={() => handleShowJsonDialog(event)}
            className="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            title={t('eventType.viewJson')}
          >
            JSON
          </button>
        )
      } */}
      <JsonDialog
        isOpen={jsonDialog.isOpen}
        onClose={handleCloseJsonDialog}
        jsonData={jsonDialog.data}
        title={jsonDialog.title}
      />
    </>
  );
};

export default EventValue;
